import { create } from 'zustand'

import { FilterPreset } from '@/gql/graphql'

type TableView = {
  tableNames: string[]
  tableName: string
  filterPresets: FilterPreset[]
  maxNumberOfColumns: number
  setFilterPresets: (filterPresets: FilterPreset[]) => void
  removeFilterPreset: (id: string) => void
  pushTableName: (tableName: string) => void
  popTableName: () => void
  setMaxNumberOfColumns: (maxNumberOfColumns: number) => void
}

const useTableViewStore = create<TableView>(set => ({
  tableNames: [],
  tableName: '',
  filterPresets: [],
  maxNumberOfColumns: 15,
  setFilterPresets: filterPresets => set({ filterPresets }),
  removeFilterPreset: id =>
    set(state => ({
      filterPresets: state.filterPresets.filter(
        filterPreset => filterPreset.id !== id,
      ),
    })),
  pushTableName: (tableName: string) => {
    set(state => ({ tableNames: [...state.tableNames, tableName], tableName }))
  },
  popTableName: () => {
    set(state => {
      const newTableNames = state.tableNames.slice(0, -1)
      return {
        tableNames: newTableNames,
        tableName: newTableNames?.slice(-1)[0],
      }
    })
  },
  setMaxNumberOfColumns: maxNumberOfColumns => set({ maxNumberOfColumns }),
}))

export default useTableViewStore
